"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllContactsDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const constants_1 = require("../../../../../../services/service-lib/src/lib/constants");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const constants_2 = require("../../../../../../../libs/service-lib/src/lib/constants");
class GetAllContactsDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
        this.contactRecordTypeLid = constants_2.DEFAULT_COMPANY_CONTACT_RECORD_TYPE;
        this.sort = constants_1.DEFAULT_VALUES.SORT_BY;
    }
}
exports.GetAllContactsDto = GetAllContactsDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Page number (default: 1)",
        example: 1,
        required: false,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    tslib_1.__metadata("design:type", Number)
], GetAllContactsDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Number of items per page (default: 10)",
        example: 10,
        required: false,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    tslib_1.__metadata("design:type", Number)
], GetAllContactsDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Contact record type id",
        example: 88,
        required: false,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    tslib_1.__metadata("design:type", Number)
], GetAllContactsDto.prototype, "contactRecordTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Field to sort by",
        example: "id",
        required: false,
    }),
    tslib_1.__metadata("design:type", String)
], GetAllContactsDto.prototype, "sort", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Search term for filtering",
        example: "Test",
        required: false,
    }),
    tslib_1.__metadata("design:type", String)
], GetAllContactsDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Field to search by (e.g., contactName, companyName, phone, status).",
        example: "companyName",
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], GetAllContactsDto.prototype, "searchBy", void 0);
